module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0106.jpg?v=c5d7f6e6";